import s from "./styles.module.sass";
import ContentAccordion from "@features/Course/parts/course/Content/parts/ContentAccordion";
import { SectionDto } from "@generated/models/SectionDto";

type ContentProps = {
	sections: Array<SectionDto>;
};

const Content = ({ sections }: ContentProps) => {
	return (
		<section className={s.courseContent}>
			<h2>Материалы курса</h2>
			<ul className={s.sections}>
				{sections.map((section, index) => {
					return (
						<li key={index}>
							<ContentAccordion section={section} />
						</li>
					);
				})}
			</ul>
		</section>
	);
};

export default Content;
